// 投稿カードの作者行 (表示名 / @ハンドル / 時刻) の省略を X の作法に揃える補助。
//
// CSS 側 (v2.css / php-style.css の .post-author-meta) で「@ハンドルが先に縮み、
// 表示名は最後に … で省略、時刻は常に出す」を作ってあるが、Chromium には
// 「内容がぴったり収まるときでも 1/64px の丸めで text-overflow: ellipsis が出る」
// 癖がある (名前の幅 112.28px に対して箱が 112.26px になる)。そのため、実際に
// 1px 以上はみ出しているときだけ ellipsis を有効にし、それ以外は clip にする。
// (clip でも 0.02px の欠けは目に見えない。)
//
// 差し込みで増えるカード (無限スクロール / 新着ピル / softnav) にも同じ判定を
// 掛けるため、timeline-media-unload.js と同じイベントで再実行する。

const SEL = '.post-author-meta .author-link';

function fixOne(a: HTMLElement): void {
  const range = document.createRange();
  range.selectNodeContents(a);
  const text = range.getBoundingClientRect().width;
  const box = a.getBoundingClientRect().width;
  if (box <= 0) return;
  // 1px 未満のはみ出しは丸めの誤差とみなす。
  a.style.textOverflow = text - box > 1 ? '' : 'clip';
}

function fixAll(root: ParentNode = document): void {
  root.querySelectorAll<HTMLElement>(SEL).forEach(fixOne);
}

let raf = 0;
function schedule(): void {
  if (raf) return;
  // rAF はヘッドレスの仮想時間で止まるので setTimeout(0) で足並みをそろえる。
  raf = window.setTimeout(() => { raf = 0; fixAll(); }, 0);
}

export function initAuthorRow(): void {
  fixAll();
  document.addEventListener('mp:timeline-appended', schedule);
  window.addEventListener('timeline-prepended', schedule);
  document.addEventListener('mp:navigated', schedule);
  window.addEventListener('resize', schedule);
  if (document.fonts && document.fonts.ready) {
    // Web フォントの読み込みで幅が変わる (system-ui なので通常は即時)。
    document.fonts.ready.then(schedule).catch(() => {});
  }
}
